export default __webpack_public_path__ + "static/media/electronic_equipments.2858442f.svg";